import type { ThemeConfiguration } from '@keyvue/one-ui';

const themeConfig: ThemeConfiguration = {
    colors: {
        default: {
            'primary': '#4AAB9A',
            'tertiary': '#4AAB9A',

            'turquoise-500': '#4AAB9A',
            'raspberry-pink-500': '#EF7D62',
            'lemon-yellow-500': '#FCC120',
        },
        hover: {
            primary: '#3B9989',
            tertiary: '#3B9989',
        },
    },
};

export default themeConfig;
